/**
 * Aba Quick replies em edição (PR4). Edita label · texto · atalho de cada quick
 * reply; adiciona e remove. Campos do mockup sem fonte (categoria, uso 30d,
 * isAction, ivr, sugestão IA) ficam fora — zero dado falso.
 */

import { Plus, Trash2 } from 'lucide-react';

import { makeQuickReply } from '../use-playbook-form';

import type { PlaybookQuickReply } from '../types';
import type { PlaybookForm } from '../use-playbook-form';

export function TabQuickRepliesEdit({ form }: { form: PlaybookForm }): JSX.Element {
  const { draft, set } = form;
  const quickReplies = draft.quickReplies;

  const update = (index: number, patch: Partial<PlaybookQuickReply>): void => {
    set(
      'quickReplies',
      quickReplies.map((qr, i) => (i === index ? { ...qr, ...patch } : qr)),
    );
  };

  const add = (): void => {
    set('quickReplies', [...quickReplies, makeQuickReply(crypto.randomUUID())]);
  };

  const remove = (index: number): void => {
    set(
      'quickReplies',
      quickReplies.filter((_, i) => i !== index),
    );
  };

  return (
    <div className="pb-panel" role="tabpanel" aria-label="Quick replies">
      <div className="pb-panel__head-row">
        <h2 className="pb-panel__title">Quick replies</h2>
        <button type="button" className="pb-btn pb-btn--sm" onClick={add}>
          <Plus size={14} /> Adicionar quick reply
        </button>
      </div>

      {quickReplies.length > 0 ? (
        <div className="pb-qr-list">
          {quickReplies.map((qr, index) => (
            <div key={qr.id} className="pb-qr-card pb-qr-card--edit">
              <div className="pb-qr-card__edit-head">
                <span className="pb-step-card__num">#{index + 1}</span>
                <button
                  type="button"
                  className="pb-btn pb-btn--ghost pb-btn--sm"
                  aria-label={`Remover quick reply ${index + 1}`}
                  onClick={() => {
                    remove(index);
                  }}
                >
                  <Trash2 size={14} />
                </button>
              </div>
              <div className="pb-field">
                <span className="pb-field__label">Rótulo (curto)</span>
                <input
                  type="text"
                  className="pb-input"
                  value={qr.label}
                  aria-label={`Rótulo da quick reply ${index + 1}`}
                  onChange={(e) => {
                    update(index, { label: e.target.value });
                  }}
                />
              </div>
              <div className="pb-field">
                <span className="pb-field__label">Texto da mensagem</span>
                <textarea
                  className="pb-textarea"
                  rows={2}
                  value={qr.text}
                  aria-label={`Texto da quick reply ${index + 1}`}
                  onChange={(e) => {
                    update(index, { text: e.target.value });
                  }}
                />
              </div>
              <div className="pb-field">
                <span className="pb-field__label">Atalho (opcional)</span>
                <input
                  type="text"
                  className="pb-input pb-input--narrow"
                  value={qr.shortcut ?? ''}
                  aria-label={`Atalho da quick reply ${index + 1}`}
                  placeholder="ex.: c"
                  onChange={(e) => {
                    update(index, { shortcut: e.target.value });
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="pb-read-value pb-read-value--muted">
          Nenhuma quick reply. Use “Adicionar quick reply” para criar a primeira.
        </p>
      )}
    </div>
  );
}
